<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;To Be Billed Transaction #{{tranReservationId}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button"
            (click)="onBack()">Back</button>

            <button (click)="getTransactionByID()" tooltip="Refresh"
            class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
            type="button">
            <span class="btn-wrapper--icon">
                <i class="ion-md-sync"></i>
            </span>
        </button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-2">
        <div class="no-gutters row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 p-4">
                <div class="divider-v divider-v-lg"></div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Res Type</div>
                                <span style="font-weight: 500;">{{paymentTransData[0]?.RES_TYPE}}</span>
                               
                            </div>
                        </div>
                        <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Station</div>
                                <span style="font-weight: 500;">{{paymentTransData[0]?.STATION}}</span>
                            </div>
                        </div>
           
<!--          
                        <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Currency</div>
                                <span style="font-weight: 500;">{{paymentTransData[0].CURRENCY_FLAG}}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-xl-4 p-4">
                <div class="divider-v divider-v-lg"></div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Res Creation Date</div>
                                <span style="font-weight: 500;">{{getDateFormat(paymentTransData[0]?.RESCREATIONDT)}}</span>
                            </div>
                        </div>
                        <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Res Start Date</div>
                                <span style="font-weight: 500;">{{getTimeFormat(paymentTransData[0]?.STARTDT)}}</span>
                            </div>
                        </div>
        
                        <!-- <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Company Name</div>
                                <span style="font-weight: 500;">{{paymentTransData[0].COMPANY_NAME }}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-xl-4 p-4">
                <div class="divider-v divider-v-lg"></div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center justify-content-between" *ngIf=" ((paymentTransData[0]?.TXREFNUM || paymentTransData[0]?.TXREFNUM == null) && paymentTransData[0]?.RES_TYPE == 'Retail' && paymentTransData[0]?.RES_TYPE != 'Retail-Web')">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Customer Bill To (Company Name)</div>
                                <span style="font-weight: 500;">{{paymentTransData[0]?.COMPANY_NAME }}</span>
                            </div>
                        </div>
                        <!-- <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Sub Total</div>
                                <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_SUBTOTAL}}</span>
                            </div>
                        </div> -->
                        <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Currency</div>
                                <span style="font-weight: 500;">{{paymentTransData[0]?.CURRENCY_FLAG}}</span>
                            </div>
                        </div>
                        <!-- <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Taxes</div>
                                <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_TAXES }}</span>
                            </div>
                        </div> -->
                        <!-- <div class="divider my-3"></div>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-black-50" style="font-size: 0.8rem;">Total Due</div>
                                <span style="font-weight: 500;">{{paymentTransData[0].TRANSACTION_TOTAL }}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-box mb-2">
    <div  class="card-body">
        <!-- <p>
            If you want to add the additional amount, update the total amount and then click on Update. <br/>
           <b> Before submitting the payment please refresh the amount, since there is a chance for the amount to get updated by another admin.</b> 
            <button (click)="getTransactionByID()" tooltip="Refresh"
            class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
            type="button">
            <span class="btn-wrapper--icon">
                <i class="ion-md-sync"></i>
            </span>
        </button>
        </p> -->
        <form [formGroup]="transactionChangeForm">
            <div class="row no-gutters " style="padding: 10px 20px;">
                <div class="col-md-2 col-sm-4  mr-4" >
                    <div class="form-group">
                        <label for="exampleEmail">Sub Total </label>
                        <input class="form-control" id="subTotal"  name="subTotal"
                            formControlName="subTotal" readOnly  type="text">
                            <!-- (ngModelChange)="amountChangeCheckingFn(f.subTotal.value)" -->
                    </div>
                </div>
                <div class="col-md-2 col-sm-4  mr-4 ">
                    <div class="form-group">
    
                        <label for="exampleEmail">Tax </label>
                        <input class="form-control" id="taxes" readOnly name="taxes"
                            formControlName="taxes"
                            type="text">
    
                    </div>
                </div>
                <div class="col-md-2 col-sm-4 mr-4">
                    <div class="form-group">
                        <label for="exampleEmail">Total Amount </label>
                        <input class="form-control" id="totalAmount" readOnly name="totalAmount"
                            formControlName="totalAmount" 
                            type="text">
    
                    </div>
                </div>
                <div class="col-md-3 d-flex align-items-center mt-4" *ngIf="paymentTransData[0]?.is_capital_one">
                    <div class="form-check">
                        <input
                                class="form-check-input"
                                type="checkbox"
                                id="capitalOneCheck"
                                [checked]="paymentTransData[0]?.is_capital_one"
                                disabled
                        />
                        <label class="form-check-label" for="capitalOneCheck">
                            Payment with capital one
                        </label>
                    </div>
                </div>
                <div class="col-md-2 mt-4 pt-1 pl-4 ml-4" *ngIf="amountChangeStatus">
                    <button id="saveContractBtn" class="btn btn-primary btn-square" type="button"
                        (click)="updateTransaction(transactionChangeForm.value)">Update</button>
                </div>
              </div>
        </form>
    </div>
    </div>
    <div>
        <!-- <button (click)="getTransactionByID()" tooltip="Refresh"
        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
        type="button">
        <span class="btn-wrapper--icon">
            <i class="ion-md-sync"></i>
        </span>
    </button> -->
   
    <div *ngIf="! paymentTransData[0]?.TXREFNUM && paymentTransData[0]?.RES_TYPE != 'Retail-Web'">


    <div class="card card-box mb-2" *ngIf="paymentTransData[0]?.PROF_CUST_REFNUM == null">
        <div class="card-body">
            <div class="" *ngIf="transactionType == 'Cheque' ">
                <form [formGroup]="chequeForm">
                    <h5 class="font-size-xl font-weight-bold">Cheque Payment </h5>
                    <p class="text-black-50 mb-4">Add require details submit the transaction</p>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group mb-5">
                                <label for="">Cheque Number * :</label>
                                <input class="form-control" formControlName="chequeNumber" placeholder="Cheque Number" type="text" [ngClass]="{'is-invalid': submitted && checkFormControls.chequeNumber.errors}">
                                <div *ngFor="let validation of validation_messages.chequeNumber">
                                    <div class="error-message" *ngIf="checkFormControls.chequeNumber.hasError(validation.type) &&  ((checkFormControls.chequeNumber.dirty || checkFormControls.chequeNumber.touched))">
                                        {{validation.message }}
                                    </div> 
                                </div>
                            </div> 
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group mb-5">
                                <label for="">Notes * :</label>
                            <textarea formControlName="notes" class="form-control" placeholder=" Notes"  name="text" rows="2" [ngClass]="{'is-invalid': submitted && checkFormControls.notes.errors}"></textarea>
                            <div *ngFor="let validation of validation_messages.notes">
                               <div class="error-message" *ngIf="checkFormControls.notes.hasError(validation.type) &&  ((checkFormControls.notes.dirty || checkFormControls.notes.touched))">
                                   {{validation.message }}
                               </div> 
                           </div>
                            </div>
                         </div>
    
                        <div class="col-md-12 py-3">
                            
                            <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button"
                                (click)="submitTransactionOfPayment(chequeForm.value)">Submit</button>
                        </div>
                    </div>
                </form>
            </div>            

            <div class="p-4" *ngIf="transactionType == 'Credit Card' ">
                <form [formGroup]="creditCardForm">
                    <h5 class="font-size-xl font-weight-bold">Credit Card Payment </h5>
                    <p class="text-black-50 mb-4"> Add Credit Card details and submit the Transaction </p>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group mb-5">
                                <label for="152">Name on the Card * :</label>
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <span class="input-group-text">
                                            <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                        </span>
                                    </span>
                                    <input formControlName="name" class="form-control" id="152" name="name" type="text" [ngClass]="{'is-invalid': submitted && formControls.name.errors}"/>
                                </div>
                                <div *ngFor="let validation of validation_messages.name">
                                    <div class="error-message" *ngIf="formControls.name.hasError(validation.type) && ((formControls.name.dirty  || formControls.name.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-5">
                                <label for="52">Credit Card Number * :</label>
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <span class="input-group-text">
                                            <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                        </span>
                                    </span>
                                    <input autocomplete="cc-number" ccNumber formControlName="creditCardNo" class="form-control" name="cc-number" type="tel"  id="cc-number"  [ngClass]="{'is-invalid': submitted && formControls.creditCardNo.errors}"/>
                                    <!-- [textMask]="{mask: maskCreditCard}" -->
                                </div>
                                <div *ngFor="let validation of validation_messages.creditCardNo">
                                    <div class="error-message" *ngIf="formControls.creditCardNo.hasError(validation.type) && ((formControls.creditCardNo.dirty  || formControls.creditCardNo.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                                <div *ngIf="isCapitalOneValidate() && !paymentTransData[0]?.is_capital_one"
                                     class="relative -top-5 text-xs"
                                >
                                    Capital One card number detected. ${{capitalOneDiscount}} discount will be applied
                                </div>
                                <div *ngIf="!isCapitalOneValidate() && creditCardForm.get('creditCardNo').value && paymentTransData[0]?.is_capital_one"
                                     class="relative -top-5 text-xs"
                                >
                                    Invalid Capital One card number. The ${{capitalOneDiscount}} discount will be removed.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-5">
                                <label for="4">Expire Date * :</label>
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <span class="input-group-text">
                                            <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                                        </span>
                                    </span>
                                    <input formControlName="expireMonthYear" [textMask]="{mask: maskDate}" class="form-control" id="4" name="date-mask" type="text"  [ngClass]="{'is-invalid': submitted && formControls.expireMonthYear.errors}"/>
                                </div>
                                <div *ngFor="let validation of validation_messages.expireMonthYear">
                                    <div class="error-message" *ngIf="formControls.expireMonthYear.hasError(validation.type) && ((formControls.expireMonthYear.dirty  || formControls.expireMonthYear.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mb-5">
                                <label for="4">CVV * :</label>
                                <div class="input-group">
                                    <span class="input-group-prepend">
                                        <span class="input-group-text">
                                            <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                                        </span>
                                    </span>
                                    <input formControlName="cvv"
                                        class="form-control" id="4" name="date-mask" type="text"  [ngClass]="{'is-invalid': submitted && formControls.cvv.errors}"/>
                                </div>
                                <div *ngFor="let validation of validation_messages.cvv">
                                    <div class="error-message" *ngIf="formControls.cvv.hasError(validation.type) && ((formControls.cvv.dirty  || formControls.cvv.touched))">
                                        {{validation.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 py-3">
                            <button id="saveContractBtn" class="btn m-2 btn-primary btn-square" type="button"
                                (click)="submitTransactionOfPayment(creditCardForm.value)">Submit</button>
                        </div>

                    </div>
                </form>
            </div>

        </div>
    </div>
    <div class="card card-box" *ngIf="paymentTransData[0]?.PROF_CUST_REFNUM != null">
        <div  class="card-body">
            <div class="row no-gutters " style="padding: 10px 20px;">
                <div class="col-md-3 col-sm-4 mr-4">
                    <div class="form-group">
                        <label for="exampleEmail">Chase Profile ID</label>
                        <input class="form-control" id="refn" readOnly name="refn"
                            value="{{paymentTransData[0]?.PROF_CUST_REFNUM}}"
                            type="text">
                    </div>
                </div>
                <div class="col-md-2 mt-4 pt-1 pl-4 ml-4">
                    <button  class="btn btn-primary btn-square" type="button"
                    (click)="markAndCaptureUsingProfile(paymentTransData[0]?.PROF_CUST_REFNUM)">Mark & Capture</button>
                </div>
                </div>
        </div>
    </div>

</div>
    <div *ngIf="paymentTransData[0]?.TXREFNUM " class="card card-box">
        <div  class="card-body">
          <p> Amount will be captured from the Transaction Reference Number  ( <span class="font-weight-bold" style="font-size: 16px;"> {{paymentTransData[0]?.TXREFNUM }}</span> ) </p>
            <br/>
             <label for="exampleEmail" *ngIf="paymentTransData[0]?.RES_TYPE == 'Retail-Web' "> Customer Reference Number: <b> {{tranReservationId}} </b></label>
             <br/>
            <button (click)="captureCCardAmount(paymentTransData[0])"
                                             class="btn btn-md btn-neutral-success btn-square"
                                                type="button">
                                                <span> Mark & Capture  the above Amount</span>
                                            </button> 

        </div> 
    </div>
</div>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>
<notifier-container></notifier-container>